import { Feature } from '@tencent/workbench';
import BaseToolbarFeature from '@framework/workbench/common/feature/base-toolbar-feature';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import { AppEntryType } from '@src/slide/infrastructure/entry/base/infrastructure-base.interface';
import { config } from './config';

@Feature()
export class InsertAddonFeature extends BaseToolbarFeature {
    id = config.id;
    constructor() {
        super();
    }

    protected getCustomDisabledState(): boolean {
        if (browser.isMobile || this.getAppService().getEntryType() !== AppEntryType.PC_EDIT) {
            return true;
        }
        const isMasterEditType = this.getAppService().editableServiceLayer
            ?.masterLayoutEditService.isMasterEditType;
        return isMasterEditType ?? false;
    }
}
